var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "md-layout md-gutter md-alignment-top-center" }, [
      _c("div", {
        staticClass:
          "md-layout-item md-size-25 md-small-size-100 md-xsmall-size-100"
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "md-layout-item md-size-50 md-small-size-100 md-xsmall-size-100"
        },
        [
          _c(
            "md-empty-state",
            {
              attrs: {
                "md-icon": "highlight_off",
                "md-label": "Ups, diese Seite konnte nicht gefunden werden.",
                "md-description":
                  "Klicken Sie unten um zurück zur Startseite zu kommen."
              }
            },
            [
              _c(
                "router-link",
                { attrs: { to: { name: "Welcome" } } },
                [
                  _c("md-button", { staticClass: "md-primary md-raised" }, [
                    _vm._v("Zurück zur Startseite")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", {
        staticClass:
          "md-layout-item md-size-25 md-small-size-100 md-xsmall-size-100"
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9a983e92", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a983e92","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landing/notfound/NotFound.vue
// module id = null
// module chunks = 